export const galleriesQueries = [
    'UserGalleries',
    'UserGalleriesWithCollaborators',
    'CompanyGalleries',
    'CompanyGalleriesWithCollaborators',
];
